import { Routes } from '@angular/router';
import { InfoscreenEntryComponent } from './infoscreen-module/infoscreen-entry.component';

export const routes: Routes = [
  {
    // Decides between the old screen (?locationId=, the default) and the infoscreen module
    // (?screenId=, or a screen that has taken over the location's old address).
    path: '',
    component: InfoscreenEntryComponent,
  },
];
